import { HTMLAttributes, useMemo } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Image from '@/components/base/Image'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

type MediaImageProps = HTMLAttributes<HTMLElement> & Partial<{ image: WPImage }>

const MediaImage = ({ image, className, ...props }: MediaImageProps) => {
  const ratio = useMemo(() => {
    const width = image?.width || 0
    const height = image?.height || 0
    return `${(height / width) * 100}%`
  }, [image])

  return (
    <Section className={cn([className])} {...props}>
      <Container>
        <Grid>
          <div className="col-span-4 md:col-span-6 lg:col-span-12">
            <div className="grid gap-y-[1rem] md:gap-y-[1.5rem]">
              <div
                className="relative h-0 w-full rounded-[3rem] bg-dark-blue"
                style={{ paddingBottom: ratio }}
              >
                <Image
                  source={image}
                  fill
                  fit="cover"
                  className="rounded-[3rem]"
                />
              </div>
              <div className="flex">
                <Typography variant="small" className="text-mainbody/40">
                  {image?.caption}
                </Typography>
              </div>
            </div>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default MediaImage
